import { render, staticRenderFns } from "./GroupPage.vue?vue&type=template&id=c6e3fcca&"
import script from "./GroupPage.vue?vue&type=script&lang=js&"
export * from "./GroupPage.vue?vue&type=script&lang=js&"
import style0 from "./GroupPage.vue?vue&type=style&index=0&id=c6e3fcca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports